import builder from '../builder';
import AllowancesSmoking from '../../streamline-icons/bold/allowances-smoking.svg';

export default builder('IconAllowancesSmokingBold', AllowancesSmoking);
